
<!-- <app-nav-bar (onToggleNavbar)="onToggleNavBar($event)"></app-nav-bar>  -->
<app-loading *ngIf="loading"></app-loading>
<router-outlet></router-outlet>



